import type { CanonicalStage, StageConfig } from '@capture/shared';
import { ImportPanel } from './stages/ImportPanel';
import { FormRecognitionPanel } from './stages/FormRecognitionPanel';
import { OcrPanel } from './stages/OcrPanel';
import { PostOcrPanel } from './stages/PostOcrPanel';
import { KeyEntryPanel } from './stages/KeyEntryPanel';
import { VerificationPanel } from './stages/VerificationPanel';
import { QaPanel } from './stages/QaPanel';
import { SupervisorPanel } from './stages/SupervisorPanel';
import { PreExportPanel } from './stages/PreExportPanel';
import { ExportPanel } from './stages/ExportPanel';
import { RawAdvancedPanel } from './stages/RawAdvancedPanel';

interface StagePanelProps {
  config: StageConfig;
  onChange: (c: StageConfig) => void;
}

const REGISTRY: Partial<Record<CanonicalStage, React.ComponentType<StagePanelProps>>> = {
  'import': ImportPanel,
  'form-recognition': FormRecognitionPanel,
  'ocr': OcrPanel,
  'post-ocr': PostOcrPanel,
  'key-entry': KeyEntryPanel,
  'verification': VerificationPanel,
  'qa': QaPanel,
  'supervisor': SupervisorPanel,
  'pre-export': PreExportPanel,
  'export': ExportPanel,
};

export function StagePanel({ stage, config, onChange }: { stage: CanonicalStage; config: StageConfig; onChange: (c: StageConfig) => void }) {
  const Panel = REGISTRY[stage] ?? RawAdvancedPanel;
  return <Panel config={config} onChange={onChange} />;
}
